import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    if (localStorage.theme == "dark") {
      localStorage.theme = "light";
      document.documentElement.classList.remove("dark");
    } else {
      localStorage.theme = "dark";
      document.documentElement.classList.add("dark");
    }
  }
}
